import { Modal } from './Shared';
import { POSITIONS, POSITION_LABELS } from '../lib/constants';

export default function PositionPickerModal({ player, otherTeam = [], otherLabel = '', onSelect, onSwap, onCancel }) {
  const preferred = player.positions || [];

  return (
    <Modal
      title={`Move ${player.name}`}
      subtitle={
        preferred.length
          ? `Prefers ${preferred.join(', ')} — currently at ${player.assignedPosition}`
          : `No preferred positions set — currently at ${player.assignedPosition}`
      }
      onClose={onCancel}
    >
      <div className="pos-grid pos-grid--picker">
        {POSITIONS.map((pos) => {
          const rank = preferred.indexOf(pos);
          return (
            <button
              type="button"
              key={pos}
              className={`pos-chip ${pos === player.assignedPosition ? 'pos-chip--on' : ''} ${
                rank > -1 ? 'pos-chip--preferred' : ''
              }`}
              onClick={() => onSelect(pos)}
              title={POSITION_LABELS[pos]}
            >
              {pos}
              {rank > -1 && <span className="pos-chip__rank">{rank + 1}</span>}
            </button>
          );
        })}
      </div>
      <p className="field__note">Positions they've listed as preferred are outlined.</p>

      {onSwap && otherTeam.length > 0 && (
        <div style={{ marginTop: 22 }}>
          <span className="field__label">Or swap with {otherLabel}</span>
          <div className="pick">
            {otherTeam.map((o) => (
              <button type="button" key={o.id} className="pick__chip" onClick={() => onSwap(o.id)}>
                {o.name}
                <span className="pick__chip-meta">{o.assignedPosition}</span>
              </button>
            ))}
          </div>
          <p className="field__note">
            The two trade sides and positions, so both teams keep their shape and stay the same size.
            Moving one player on their own would leave the sides uneven.
          </p>
        </div>
      )}
    </Modal>
  );
}
